<template>
  <modal name="dataListModal" ref="refdataListModal"
      :width="450"
      :height="230"
      :draggable="true"
      :resizable="false"
      :reset="true"
      :scrollable="true"
      :clickToClose="false"
      :shiftX="1"
      :shiftY="1"
      :adaptive="true">
    <div id="layer-popup">
        <div class="popup-header">
            <h2>항목리스트</h2>
            <button type="button" class="popup-close" @click="this.closeDataListBoard">
              <img src="../assets/web/images/icon_popup_close.png" alt="팝업닫기" title="팝업닫기">
            </button>
        </div>
        <div class="popup-cnt" style="font-weight: 500;">
          <ul class="chk-list">
            <li class="chk-label" v-for="(item, itemIdx) in this.statItems" v-bind:key="itemIdx">
              <button type="button" class="fa fa-times" aria-hidden="true" v-on:click="closeStatItem(item)" style="color:#ffffff;border:1px solid #ff0000;border-radius:5px;width:25px;height:25px;background:#ff0000;"></button>
              <h2>{{item.mapSysNm}}</h2>
              <ul class="check-list">
                  <li>
                    <span>{{item.info.mapItmOutNm}}</span>
                  </li>
              </ul>
              <ul class="check-list year">
                  <li v-for="(yearItem, yearItemIdx) in item.years" v-bind:key="yearItemIdx">
                      <span>{{yearItem}}</span>
                  </li>
              </ul>
            </li>
          </ul>
        </div>
    </div>
  </modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { eventBus } from '@/event-bus'

const statItemStore = 'statItemStore'

export default {
  name: 'DataListBoard',
  components: {},
  computed: {
    ...mapState(statItemStore, {
      statItems: state => state.statItems
    })
  },

  data () {
    return {}
  },
  created () {
    eventBus.$on('showDataListBoard', () => {
      this.$modal.show('dataListModal')
    })
  },

  mounted () {
  },

  beforeDestroy () {
    this.closeDataListBoard()
  },

  methods: {
    ...mapActions(statItemStore, {
      removeStatItem: 'removeStatItem'
    }),
    closeStatItem (statItem) {
      eventBus.$emit('sendCloseStatItem', statItem.info)
    },
    closeDataListBoard  () {
      this.$modal.hide('dataListModal')
    }
  }
}
</script>

<style scoped>
.vm--container {
  width: 0px;
  height: 0px;
  z-index: 1000;
}

</style>

<style>
.vm--overlay[data-modal="dataListModal"] {
  width: 0px;
  height: 0px;
  background: transparent;
}
</style>
